
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface SubmitButtonProps {
  isSubmitting: boolean;
  disabled: boolean;
  onClick: () => void;
}

const SubmitButton = ({ isSubmitting, disabled, onClick }: SubmitButtonProps) => {
  return (
    <div className="flex justify-center">
      <Button
        onClick={onClick}
        disabled={disabled || isSubmitting}
        variant="purple"
        className="w-full sm:w-auto text-white hover:text-white"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Submitting...
          </>
        ) : (
          "Submit Verification Request"
        )}
      </Button>
    </div>
  );
};

export default SubmitButton;
